export const getDefaultState = () => {
    return {
        companies: [],
        company: {
            name: null,
            description: null,
        },
        validation_company: {
            name: null,
            description: null,
        },
        search:{
            name: null,
            description: null,
        }
    }
}
export default getDefaultState()